import { createIcon } from "@chakra-ui/icons";

// Created from folder.svg

export const FolderOpenIcon = createIcon({
  displayName: "FolderOpen",
  viewBox: "0 0 24 20",
  path: (
    <>
      <path
        d="M21.25 4.24316C21.9586 4.24316 22.6501 4.49955 23.1699 4.97461C23.6919 5.45189 24 6.11467 24 6.82129C24 6.89129 23.99 6.96104 23.9707 7.02832L20.9707 17.457C20.9356 17.5791 20.8701 17.6905 20.7803 17.7803L20.2803 18.2803C20.2724 18.2882 20.2641 18.2962 20.2559 18.3037C19.7338 18.7809 19.127 18.9999 18.4219 19H6.33594C5.92896 19 5.52872 18.9122 5.16211 18.75H17.8496C18.3535 18.75 18.837 18.5391 19.1934 18.1641C19.5497 17.789 19.75 17.2804 19.75 16.75V5.75C19.75 5.21957 19.5497 4.71101 19.1934 4.33594C19.1623 4.3032 19.1287 4.27337 19.0957 4.24316H21.25ZM10.25 1.5C10.4896 1.5 10.7153 1.61497 10.8564 1.80859L12.2725 3.75H9.2998L7.875 1.5H10.25Z"
        fill="currentColor"
      />
      <path
        d="M20.75 16.75C20.75 16.75 20.5393 17.7891 20.1642 18.1642C19.7891 18.5393 19.2804 18.75 18.75 18.75H2.75C2.21957 18.75 1.71086 18.5393 1.33579 18.1642C0.960714 17.7891 0.75 17.2804 0.75 16.75V2.75C0.75 2.21957 0.960714 1.71086 1.33579 1.33579C1.71086 0.960714 2.21957 0.75 2.75 0.75H7.75L9.75 3.75H18.75C19.2804 3.75 19.7891 3.96071 20.1642 4.33579C20.5393 4.71086 20.75 5.21957 20.75 5.75V16.75Z"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});
